export enum ReportSendType {
	email = "email",
	ftp = "ftp",
	sftp = "sftp",
	json = "json"
}
